module.exports = __webpack_public_path__ + "img/people-outline.8e68a0b3.svg";